
import type { PropOptions } from 'vue';
import Vue from 'vue';
import PinnedIcon from './images/pinned.vue.svg';
import type { IPost } from '@/types/community';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import WarRoomPinnedPost from '@/components/partials/war-room/WarRoomPinnedPosts/WarRoomPinnedPost.vue';
import WarRoomPostPreview from '@/components/partials/war-room/WarRoomPostPreview.vue';

export default Vue.extend({
  name: 'WarRoomPinnedPosts',
  components: {
    BravadoText,
    PinnedIcon,
    WarRoomPostPreview,
    WarRoomPinnedPost,
  },
  props: {
    pinnedPosts: {
      type: Array,
      required: true,
    } as PropOptions<IPost[]>,
  },
  computed: {
    hasOnePinned(): boolean {
      return (this.pinnedPosts as IPost[]).length === 1;
    },
    pinnedPost(): IPost {
      const [post] = this.pinnedPosts as IPost[];
      return post;
    },
  },
  methods: {
    handleClick(post: IPost, isContextMenu = false): void {
      this.$emit('on-click-post', { post, isContextMenu });
    },
  },
});
